import React from 'react'

const ListaAsistentes = ({asistentes}) => {
    return (

        <table className="table">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Correo</th>
                    <th scope="col">¿Editar?</th>
                </tr>
            </thead>
            <tbody>
                {
                    asistentes.map( (asistente, i) => (
                        <tr key={asistente._id}>
                            <th scope='row'>{i+1}</th>
                            <td> { asistente.nombre } </td>
                            <td> { asistente.correo } </td>
                        </tr>
                    ))
                }
            </tbody>
        </table>

    )
}

export default ListaAsistentes
